import {
  dateOperating,
  clSortDatas
} from '@/cllib/tools'

import store from '@/store'

import sysEnv from '@/env/envs'

export const dealCarDatas = (datas) => {
  datas.forEach((item) => {
    item['signText'] = item['signStatus'] === 0 ? '未签到' : '已签到'
    item['statusText'] = item['status'] === '1' ? '在用' : '停用'
    item['wxSignText'] = item['signText'] === '已签到' ? (item['wxSign'] ? '是' : '否') : ''
    item['wayHour'] = item['wayHour'] ? Number(item['wayHour'].toFixed(2)) : item['wayHour']
    item['isEmergencyText'] = item['isEmergency'] ? '是' : '否'
    item['carRatio'] = item['carRatio'] ? Number((item['carRatio'] * 100).toFixed(0)) : ''
    let total = 0
    let carbinList = item.carbinList || []
    carbinList.sort((a, b) => a.carBinNo - b.carBinNo)
    carbinList.forEach((itemCarBin) => {
      total += itemCarBin.validCapacity
    })
    item['preArriveDepotTimes'] = item['preArriveDepotTime']
    item['preArriveDepotTime'] = item['preArriveDepotTime'] ? dateOperating.formatDate({date: item['preArriveDepotTime'], format: 'date'}) : null
    item['numCabin'] = carbinList.length
    item['total'] = total
  })
  return datas
}

export const oilColor = {
  '0': '#03904a',
  '92': '#f98b06',
  '95': '#eb3b0a',
  '98': '#0076c8',
  '汽': '#f98b06',
  '柴': '#03904a'
}

// 聚合
export const pointAggregation = (datas, zomm, limit = 0) => {
  if (zomm > 11) {
    return datas
  }
  let height = 0.1 * Math.pow(2, (10 - zomm))
  let newDataMap = {}
  let newData = []
  datas.forEach((item) => {
    let key = parseInt(item.value[0] / height) + '_' + parseInt(item.value[1] / height)
    if (!newDataMap[key]) {
      newData.push(item)
      newDataMap[key] = []
    }
    newDataMap[key].push(item)
  })
  let oneData = []
  for (let key in newDataMap) {
    if (newDataMap[key].length === 1) {
      oneData.push(newDataMap[key][0])
    } else if ((limit === false || limit === undefined) || newDataMap[key].length >= limit) {
      oneData.push({name: newDataMap[key].length, value: getMergePoint(newDataMap[key], height), data: newDataMap[key]})
    }
  }
  return oneData
}

const getMergePoint = (datas, height) => {
  let newPoint = [0, 0]
  datas.forEach((item) => {
    newPoint[0] += item.value[0]
    newPoint[1] += item.value[1]
  })
  newPoint[0] = newPoint[0] / datas.length
  newPoint[1] = newPoint[1] / datas.length
  return newPoint
}

export const getColorByOilName = (oilName) => {
  let color = ''
  if (oilName.includes('0')) {
    color = oilColor['0']
  } else if (oilName.includes('92')) {
    color = oilColor['92']
  } else if (oilName.includes('95')) {
    color = oilColor['95']
  } else if (oilName.includes('98')) {
    color = oilColor['98']
  }
  if (oilName === '汽') {
    color = oilColor['汽']
  } else if (oilName === '柴') {
    color = oilColor['柴']
  }
  return color
}

export const getDensityByOilType = (oilName) => {
  return oilName.includes('汽油') ? 0.73 : 0.835
}

export const tConvertL = (volume, oilName) => {
  return (volume * 1000 / getDensityByOilType(oilName)).toFixed(0)
}

export const lConvertT = (volume, oilName) => {
  return (volume / 1000 * getDensityByOilType(oilName)).toFixed(2)
}

export const dataMap = () => {
  let dateToady = new Date(dateOperating.formatDate({date: new Date(), format: 'yy-mm-dd'}) + 'T00:00:00')
  let evn = sysEnv
  if (evn && evn.env === 'zshYnDemo') {
    dateToady = new Date('2018-07-19T00:00:00')
  }
  let monthDayStr = dateOperating.formatDate({date: dateToady, format: 'yy-mm-dd'}) + 'T00:00:00'
  monthDayStr = monthDayStr.slice(0, 8) + '01' + monthDayStr.slice(10)
  return {
    monthDay: new Date(monthDayStr),
    today: dateToady,
    todayStr: dateOperating.formatDate({date: dateToady, format: 'yy-mm-dd'}),
    tomorrow: dateOperating.computeDay({days: 1, date: dateToady, format: 'Date'}),
    tomorrowStr: dateOperating.computeDay({days: 1, date: dateToady, format: 'yy-mm-dd'}),
    yesterday: dateOperating.computeDay({days: -1, date: dateToady, format: 'Date'}),
    yesterdayStr: dateOperating.computeDay({days: -1, date: dateToady, format: 'yy-mm-dd'}),
    lastWeek: dateOperating.computeDay({days: -7, date: dateToady, format: 'Date'}),
    lastWeekStr: dateOperating.computeDay({days: -7, date: dateToady, format: 'yy-mm-dd'})
  }
}

const getTextByIdStrs = (idStrs, dataMap) => {
  if (!idStrs) {
    return ''
  }
  let dataList = []
  let idList = idStrs.split(',')
  idList.forEach((item) => {
    let a = dataMap[Number(item)]
    if (a) {
      dataList.push(dataMap[Number(item)])
    }
  })
  return dataList.join(',')
}

export const dealGasOrder = (datas) => {
  let carListMap = {}
  store.getters.signCar.forEach((item) => {
    carListMap[item.id] = item.licenseNo
  })
  datas.forEach((item) => {
    item['carIdsText'] = getTextByIdStrs(item['carIds'], carListMap)
    item['exCarIdsText'] = getTextByIdStrs(item['exCarIds'], carListMap)
    item['gatePass'] = item['gatePass'] || ''
    let volumeD = item.oilType === '汽油' ? item.volume * 0.74 / 1000 : item.volume * 0.84 / 1000
    item['isSendText'] = item.isSend ? '确认' : null
    item['volumeD'] = volumeD.toFixed(1)
    item['voerRate'] = parseInt((item.piVolume || 0) / item.volume * 100) + '%'
    item['oilTypeJ'] = item.oilName ? (item.oilName.split('号')[0] + '#') : ''
    item['oilName'] = item.oilName || ''
    item['sendTimeSort'] = item.sendTime ? item.sendTime.slice(5, 10) : '--'
    item['volume'] = parseInt(item.volume || 0)
    item['gatePassText'] = item['requireGatePass'] ? '需要' : null
    item['routerVolume'] = item.routerVolume || 0
    item['routeRate'] = item.volume ? ((item.routerVolume || 0) / item.volume).toFixed(2) : ''
    item['simpleName'] = item.simpleName || item.simpleName2
    item['willEmptyVolume'] = (parseInt(item.emptyVolume || 0) + parseInt(item.outVolume || 0) - parseInt(item.notinVolume || 0)).toFixed(0)
    item['overStockStatusText'] = item.overStockStatus ? '是' : '否'
    item['recordVolume'] = item.recordVolume || 0
    item['useHistoryTodayText'] = item.volumeToday !== null ? (item.useHistoryToday ? '可靠' : '不可靠') : ''
    item['useHistoryTomorrowText'] = item.volumeTomorrow !== null ? (item.useHistoryTomorrow ? '可靠' : '不可靠') : ''
    item['useHistoryAfterTomorrowText'] = item.volumeAfterTomorrow !== null ? (item.useHistoryAfterTomorrow ? '可靠' : '不可靠') : ''
    // item['volumeToday'] = item.volumeToday ? Number(item.volumeToday).toFixed(0) : null
    // item['volumeTomorrow'] = item.volumeTomorrow ? Number(item.volumeTomorrow).toFixed(0) : null
    // item['volumeAfterTomorrow'] = item.volumeAfterTomorrow ? item.volumeAfterTomorrow.toFixed(0) : null
  })
  return datas
}

export const getTankMarkByData = (data, key) => {
  key = key || 'tankMark'
  let tankMark = []
  let tankMarkList = []
  let tankMarkList2 = []
  data.forEach((item) => {
    if (item[key] && !tankMark.includes(item[key])) {
      tankMark.push(item[key])
      if (item[key].includes('拟')) {
        tankMarkList2.push({
          key: item[key],
          label: item[key]
        })
      } else {
        tankMarkList.push({
          key: item[key],
          label: item[key]
        })
      }
    }
  })
  let funSort = function (a, b) {
    if (a && b) {
      return a.split('拟').join('') > b.split('拟').join('')
    } else {
      return true
    }
  }
  tankMarkList = clSortDatas({datas: tankMarkList, funSort: funSort, key: 'key'})
  tankMarkList2 = clSortDatas({datas: tankMarkList2, funSort: funSort, key: 'key'})
  return tankMarkList.concat(tankMarkList2)
}

export const getCarTeamByData = (data, key) => {
  key = key || 'simpleName'
  let tankMark = []
  let tankMarkList = []
  data.forEach((item) => {
    if (item[key] && !tankMark.includes(item[key])) {
      tankMark.push(item[key])
      tankMarkList.push({
        key: item[key],
        label: item[key]
      })
    }
  })
  return tankMarkList
}

export const dealGasRouteOrder = (datas) => {
  datas.forEach((item) => {
    item['oilTypeJ'] = item.oilName ? (item.oilName.split('号')[0] + '#') : ''
    item['sendTimeSort'] = item.sendTime ? item.sendTime.slice(5, 10) : '--'
    item['expectArriveTimeS'] = item.expectArriveTime ? item.expectArriveTime.slice(5, 16) : '--'
    item['carRatio'] = item['carRatio'] ? Number((item['carRatio'] * 100).toFixed(0)) : ''
    item.checkStatusText = item.checkStatus === '已审批' ? '已审批' : '未审批'
  })
  return datas
}

export const dealDriver = (datas) => {
  datas.forEach((item) => {
    item['blackText'] = item.black ? '黑名单' : ''
  })
  return datas
}



// WEBPACK FOOTER //
// ./src/cllib/sys_lib.js